/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotesAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2Notepad from 'DesignSystem/Svgs/Tysiav2Notepad/index'



/** @type {import('Simple/types.js').View} */
export default function NotesAction({
  children,
  viewPath = "/DesignSystem/ProfileActions/NotesAction",
  type = "secondary"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  type
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type={type}
 title="Notes"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2Notepad
{...childProps}
  viewPath={`${viewPath}/Tysiav2Notepad`}
 width={type === 'ghost' ? "14px" : "12px"}
 height={type === 'ghost' ? "14px" : "12px"}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}